module.exports = __webpack_public_path__ + "static/Leo-Pic-1235cd29bde6cc974fdfc99efc893457.jpg";